import script from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSwitch.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSwitch.vue?vue&type=style&index=0&id=f3514a88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3514a88"]])

export default __exports__